import React from "react"
import PlainCell from "./PlainCell"
import { StyledSelectField } from "./styles"
import { toBool } from "../../../utils/stringHelpers"

const RatingFieldCell = ({
  value,
  column: { id },
  row: {
    original: { locked }
  }
}) => {
  return (value === null || value === undefined) && !toBool(locked) ? (
    <StyledSelectField name={id} options={[...Array(11).keys()].map((o) => [o, o])} blank="Select" />
  ) : (
    <PlainCell value={value || "-"} />
  )
}

export default RatingFieldCell
